const kgFormat = (digits: number) =>
  new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: digits });

/** Grams as kg, e.g. "12,5 kg". */
export function formatKg(grams: number, digits = 2): string {
  return `${kgFormat(digits).format(grams / 1000)} kg`;
}

/** Water content, e.g. "17,4 %". */
export function formatPercent(value: number, digits = 1): string {
  return `${new Intl.NumberFormat('de-DE', { maximumFractionDigits: digits }).format(value)} %`;
}

/** Share of a total in percent, rounded to whole numbers. */
export function shareOf(part: number, total: number): number {
  return total > 0 ? Math.round((part / total) * 100) : 0;
}

/** Splits `total` evenly onto `count` parts to the gram (like the server). */
export function splitEvenly(total: number, count: number): number[] {
  if (count <= 0) return [];
  const base = Math.floor(total / count);
  const extra = total % count;
  return Array.from({ length: count }, (_, i) => base + (i < extra ? 1 : 0));
}

/** The harvest date plus two years (default best-before, specs/05). */
export function defaultBestBefore(harvestedOn: string): string {
  const [y, m, d] = harvestedOn.split('-').map(Number) as [number, number, number];
  const date = new Date(Date.UTC(y + 2, m - 1, d));
  // 29 February → 28 February like the server's month arithmetic.
  if (date.getUTCMonth() !== m - 1) date.setUTCDate(0);
  return date.toISOString().slice(0, 10);
}
